export const survey = {
    meta: {
        title: 'Doctors Survey',
        description: 'Help us improve healthcare. Participate in our survey for doctors.',
    },
    page: {
        title: 'Doctors Survey',
        subtitle: 'Your opinion matters! Help us tailor TerminTeiler to your practice needs.',
    },
    participation: {
        label: 'How would you like to participate?',
        anonymous: 'Anonymous',
        withPracticeData: 'With practice data (for queries/pilot project)',
        practiceName: 'Practice Name',
        contactPerson: 'Contact Person',
        contactPlaceholder: 'Name of contact person',
    },
    questions: {
        q1: {
            label: '1. Which tasks take up a particularly large amount of time in everyday practice?',
            options: {
                phone_changes: 'Telephone appointment changes',
                availability_inquiries: 'Inquiries about available appointments',
                short_notice_absences: 'Organization of short-notice absences',
                documentation_changes: 'Documentation of changes',
                other_tasks: 'Other organizational tasks',
            },
        },
        q2: {
            label: '2. How often do appointments become available at short notice?',
            options: {
                very_often: 'Very often',
                often: 'Often',
                sometimes: 'Sometimes',
                rarely: 'Rarely',
            },
        },
        q3: {
            label: '3. To what extent would digital solutions help handle short-notice appointment changes more structurally?',
            options: {
                very_strong: 'Very strongly',
                strong: 'Strongly',
                somewhat: 'Somewhat',
                hardly: 'Hardly',
            },
        },
        q4: {
            label: '4. Which aspects would be a relief for you personally?',
            options: {
                fewer_interruptions: 'Fewer telephone interruptions',
                clear_overview: 'Clear overview of appointment status',
                fewer_spontaneous_coordination: 'Fewer spontaneous coordinations',
                predictable_day: 'More predictable daily routine',
                calmer_phases: 'Calmer work phases',
            },
        },
        q5: {
            label: '5. How helpful would the following functions be for your everyday work? (1 = little / 5 = very helpful)',
            subLabels: {
                a: 'a) Digital forwarding of vacated appointments',
                b: 'b) Automatic time window for refilling',
                c: 'c) Short digital message to patients instead of phone call',
                d: 'd) Clear indication of appointment purpose (e.g., "Acute", "Check-up")',
            },
            scale: {
                low: 'Little help',
                high: 'Very helpful',
            },
        },
        q6: {
            label: '6. Which form of communication would be more pleasant for you in everyday life? (Multiple selection possible)',
            options: {
                short_digital: 'Short digital message',
                structured_phone: 'Telephone but structured',
                combination: 'Combination of both',
            },
        },
        q7: {
            label: '7. How important is it to you that new digital solutions do not make everyday practice more complicated, but clearer?',
            options: {
                very_important: 'Very important',
                important: 'Important',
                rather_important: 'Rather important',
                less_important: 'Less important',
            },
        },
        q8: {
            label: '8. Under what conditions would you perceive a digital system as support?',
            options: {
                simple_usage: 'Simple operation',
                clear_responsibilities: 'Clear responsibilities',
                no_extra_effort: 'No extra effort',
                transparent_processes: 'Transparent processes',
            },
        },
        q9: {
            label: '9. What impact do missed appointments have on your practice?',
            options: {
                revenue_loss: 'Revenue losses',
                room_idle: 'Idle treatment rooms',
                staff_idle: 'Idle staff',
                unproductive_slots: 'Unproductive time slots',
                workflow_disruption: 'Disruptions in practice workflow',
                other: 'Other (please specify)',
            },
            otherPlaceholder: 'Please explain...',
        },
        q10: {
            label: '10. Are there appointments in your practice whose cancellation is economically particularly relevant?',
            options: {
                yes: 'Yes',
                partial: 'Partially',
                no: 'No',
            },
            followUp: {
                label: 'If yes, which ones?',
                options: {
                    dental: 'Dental treatments',
                    specialist_first: 'Specialist initial appointments',
                    longer_treatments: 'Longer treatment times',
                    equipment_expensive: 'Apparatus services (MRI, CT etc.)',
                    private_services: 'Private services / IGeL',
                },
            },
        },
        q11: {
            label: '11. How strongly do you estimate the economic damage caused by missed appointments?',
            options: {
                very_high: 'Very high',
                high: 'High',
                medium: 'Medium',
                low: 'Low',
            },
        },
        q12: {
            label: '12. Which factors reinforce the economic disadvantage of no-shows?',
            options: {
                fixed_costs: 'Running fixed costs (staff, rent)',
                short_term_non_replacement: 'Short-term non-replaceability',
                special_preparation: 'Special preparation was necessary',
                limited_availability: 'Limited appointment availability in general',
            },
        },
        q13: {
            label: '13. How relevant would this be economically for your practice? (if a system avoids a few failures/month)',
            options: {
                very_relevant: 'Very relevant',
                relevant: 'Relevant',
                barely_relevant: 'Barely relevant',
            },
        },
        q14: {
            label: '14. Could you imagine testing such a system in a pilot phase?',
            options: {
                yes: 'Yes',
                rather_yes: 'Rather yes',
                under_conditions: 'Under certain conditions',
            },
        },
        q15: {
            label: '15. Which monthly price category would you find acceptable?',
            options: {
                basis: 'Basic (99–149 €)',
                standard: 'Standard (149–249 €)',
                premium: 'Premium (249–399 €)',
                skip: 'No answer / Don\'t know',
            },
        },
        q16: {
            label: '16. From what monthly amount would the use no longer be economically worthwhile?',
            placeholder: 'Enter amount...',
        },
        q17: {
            label: '17. Contact (optional)',
            description: 'Would you like to be informed about the results or participate in the pilot phase?',
            personPlaceholder: 'Contact Person',
            detailsPlaceholder: 'Phone Number / Email',
        },
    },
    submit: {
        button: 'Submit Survey',
        sending: 'Sending...',
        success: 'Thank you for your participation!',
        error: 'Error sending. Please try again.',
    },
    validation: {
        required: 'This is a required field.',
        selectOne: 'Please select an option.',
        selectAtLeastOne: 'Please select at least one option.',
        enterText: 'Please enter text.',
    },
};
